import { render, staticRenderFns } from "./host-supply-company-info.vue?vue&type=template&id=0b370618&scoped=true&"
import script from "./host-supply-company-info.vue?vue&type=script&lang=js&"
export * from "./host-supply-company-info.vue?vue&type=script&lang=js&"
import style0 from "./host-supply-company-info.vue?vue&type=style&index=0&id=0b370618&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b370618",
  null
  
)

export default component.exports